"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
const menu_style_1 = require("../../components/menu/menu.style");
exports.CSS = {
    container: 'c-FormShare',
    isLoading: 'c-FormShare--IsLoading',
    content: 'c-FormShare__Content',
    menu: 'c-FormShare__Menu',
};
exports.Style = {
    [exports.CSS.container]: {
        width: '600px',
    },
    [exports.CSS.isLoading]: {
        display: 'flex',
        'justify-content': 'center',
    },
    [exports.CSS.content]: {
        display: 'flex',
        'align-items': 'baseline',
        'justify-content': 'space-around',
    },
    [exports.CSS.menu]: {
        width: '600px',
        position: 'absolute',
        [`& .${menu_style_1.CSS.menu}`]: {
            right: 'auto',
            width: '100%',
        },
    },
};
//# sourceMappingURL=form.share.modal.style.js.map